module.exports = __webpack_public_path__ + "media/images/real_snacks_cover-cf18dc755e242ce635ee459f3e80ac17.jpg";